export class FiltroVwAplicacoesLavoura{
    EmpresaId: number = 0;
    StatusOS: number = 0;
    SafraId: number = 0;
    GrupoProdutoId: number = 0;
    TipoOS:number = 0;
    ProdutoId: number = 0;
}
